
/* APPLICATION ROUTE CONSTANTS */
module.exports = Object.freeze({
  
    ROW_PER_PAGE : [10, 50, 100, 300, 500],

    // Status
    STATUS_REGISTER:'Register',

    /* Routers Link supplier_app */
    APP_HOME: '/applications',
    HOME: '/home',
    
    HOME_INTRO:'/pdm-intro',
    DASHBOARD: '/pdm-dashboard',
    INBOX: '/pdm-inbox',
    OUTBOX: '/pdm-outbox',

   /* Master */







})  

